import React, { useState } from 'react';

import { Checkbox, HStack, Image, Text, VStack } from '@chakra-ui/react';
import { BrainIcon } from 'lucide-react';

import { Button } from '@/components/core/Button';

export interface AiDisclaimerContentProps {
  onAccept: () => void;
}

export const AiDisclaimerContent: React.FC<AiDisclaimerContentProps> = ({
  onAccept,
}) => {
  const [acknowledged, setAcknowledged] = useState(false);

  return (
    <VStack gap={{ base: 6, lg: 8 }} align='flex-start' p={{ base: 6, lg: 8 }}>
      <VStack gap={5} align='flex-start' width='100%'>
        <HStack gap={{ base: 3.5, lg: 4 }}>
          <Image
            src='/ai-disclaimer.svg'
            alt='AI Learning'
            rounded='full'
            boxSize={8}
            fallback={<BrainIcon size={16} />}
          />
          <Text size='headingPrimary'>Early access notice</Text>
        </HStack>
        <Text size='primaryRegular'>
          Our AI is still learning. Some responses may be inaccurate or
          incomplete. Use the information carefully and double-check important
          details.
        </Text>
        <Checkbox
          isChecked={acknowledged}
          onChange={e => setAcknowledged(e.target.checked)}
        >
          <Text>I understand</Text>
        </Checkbox>
      </VStack>

      <Button onClick={onAccept} size='xl' disabled={!acknowledged}>
        Continue
      </Button>
    </VStack>
  );
};
